angular.module('myApp.directives')
    .directive('noAudioMessage', function () {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element, attrs) {
            },
            controller: function ($scope, $element, $attrs, $transclude, audioVideoResponse, clientTools) {
                var message = $scope.avOptions.isTestVersion == 'yes' ? $attrs.noAudioMessageTest : $attrs.noAudioMessage;
                var noAudioMessage = message.replace(/<link1>(.*)<\/link1>/, '<a href="#" data-type="'+audioVideoResponse.typeVideo+'">$1</a>').replace(/<link2>(.*)<\/link2>/, '<a href="#" data-type="'+audioVideoResponse.typeText+'">$1</a>');
                $element.append(noAudioMessage);
                $element.find('a').on("click", function () {
                    var type = $(this).attr("data-type");
                    if (!clientTools.isMobileLayout()) {
                        $scope.changeResponseType(type);
                        if (type !== audioVideoResponse.typeText && $scope.hasSupportGetUserMedia) {
                            $scope.$parent.$broadcast('startUserMedia');
                        }
                    } else {
                        if (type == audioVideoResponse.typeText) {
                            if ($scope.hasSupportGetUserMedia) {
                                $scope.resetRecorders();
                            } else {
                                $scope.changeResponseType(type);
                            }
                            $scope.setAudioVideoQId(null);
                        } else {
                            if ($scope.hasSupportGetUserMedia) {
                                $scope.$parent.$broadcast('startUserMedia');
                            } else {
                                $scope.changeResponseType(type);
                            }
                        }
                    }
                });
            }
        }
    });